module.exports = __webpack_public_path__ + "img/shoethumb.0d8f2b1f.gif";